<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-bookingsettings">
    </smr-stylist-picker>
    <ion-buttons slot="end">
      <ion-button 
        class="hidden-sm-down"
        color="primary"
        fill="solid"
        (click)="onBookingSettingsSave()"
        >
        Save
      </ion-button>      
    </ion-buttons> 
  </ion-toolbar>

</ion-header>

<ion-content>

  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>  

  <salonmonster-tap-retry *ngIf="errorOccurredWhileLoadingStylistPicker" (click)="onTapToReload()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker">
  <ion-item text-wrap lines="none">
    <h3>Control how and when your clients can book with you.</h3>
  </ion-item>
  <form [formGroup]='bookingSettingsForm'>
    <ion-row>
          <ion-col size="12" size-sm="12" size-md="12" size-lg="6" size-xl="6">
            <ion-card>
              <ion-card-header><ion-card-title>Client booking preferences</ion-card-title></ion-card-header>        
              <ion-item lines="none" class='booking-preference ion-padding-left ion-padding-right'>
                <ion-note pale class="label-note">Require your approval before online bookings are finalized</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Require approval</ion-label>
                <ion-toggle formControlName="confirmApptsManually"></ion-toggle>
              </ion-item>                              
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">How close to the appointment time can a client book online?</ion-note>
              </ion-item>
              <ion-item lines="none">                
                <ion-label class="ion-text-wrap">Allow bookings up to </ion-label>
                <ion-select formControlName="allowBookingsUntil">
                  <ion-select-option *ngFor="let slots of allowBookingSlots" [value]="slots.value">
                    {{ slots.text }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">How far in the future can a client book online?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Allow bookings</ion-label>
                <ion-select formControlName="bookingHorizon">
                  <ion-select-option *ngFor="let slots of bookingHorizonSlots" [value]="slots.value">
                    {{ slots.text }}
                  </ion-select-option>
                </ion-select>
              </ion-item>     
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">What time interval can clients book at?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Offer bookings every</ion-label>
                <ion-select formControlName="bookingInterval">
                  <ion-select-option *ngFor="let slots of bookingIntervalSlots" [value]="slots.value">
                    {{ slots.text }}
                  </ion-select-option>
                </ion-select>
              </ion-item>                       
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">How long before the appointment should reminders be sent?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Send reminders</ion-label>
                <ion-select formControlName="sendAppointmentReminderBefore">
                  <ion-select-option *ngFor="let slots of sendReminderSlots" [value]="slots.value">
                    {{ slots.text }}
                  </ion-select-option>
                </ion-select>
              </ion-item>     
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">Allow new clients to create their own online booking accounts?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Allow new clients</ion-label>
                <ion-toggle formControlName="letClientsRegister"></ion-toggle>
              </ion-item>                       
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">Allow clients to cancel their appointments online?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Allow cancellations</ion-label>
                <ion-toggle formControlName="letClientsCancel"></ion-toggle>
              </ion-item>              
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">How close to their appointment can a client cancel or reschedule?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Allow cancellation/rescheduling up to</ion-label>
                <ion-select formControlName="allowCancellationUntil">
                  <ion-select-option *ngFor="let slots of allowCancellationUntilSlots" [value]="slots.value">
                    {{ slots.text }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">Allow clients to reschedule their appointments online?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Clients can reschedule</ion-label>
                <ion-toggle formControlName="isRebook"></ion-toggle>
              </ion-item>
              <ion-item class='booking-preference ion-padding-left ion padding-right' lines="none">
                <ion-note pale class="label-note">Don't show service durations to clients</ion-note>
              </ion-item>              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Hide durations</ion-label>
                <ion-toggle formControlName="hideDurations"></ion-toggle>
              </ion-item>
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">Allow clients to add themselves to a waiting list</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Enable waiting list</ion-label>
                <ion-toggle formControlName="waitingList"></ion-toggle>
              </ion-item>
              <ion-item class='booking-preference ion-padding-left ion-padding-right' lines="none">
                <ion-note pale class="label-note">Allow clients to register & log in using Facebook</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Enable Facebook login</ion-label>
                <ion-toggle formControlName="letClientsUseFBLogin"></ion-toggle>
              </ion-item>
            </ion-card>

  <!--           <ion-item>
              <ion-label stacked>Booking introduction</ion-label>
              <ion-textarea formControlName="bookingIntro" rows="5"></ion-textarea>
            </ion-item> -->
      
            <br/>
            <br/>
          </ion-col>        
        <ion-col size="12" size-sm="12" size-md="12" size-lg="6" size-xl="6">
            <ion-card>
              <ion-card-header>
                <ion-card-title>Your booking management</ion-card-title>
              </ion-card-header>
              <ion-item class='booking-preference ion-padding-right' lines="none">
                <ion-note pale class="label-note">Recommend rebooking before checking out a booking?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Prompt to rebook</ion-label>
                <ion-toggle formControlName="suggestRebookingBeforeCheckout"></ion-toggle>
              </ion-item>
              <ion-item class='booking-preference ion-padding-right' lines="none">
                <ion-note pale class="label-note">Send you a copy of client reminder emails?</ion-note>
              </ion-item>
              <ion-item lines="none">
                <ion-label class="ion-text-wrap">Copy me on reminder emails</ion-label>
                <ion-toggle formControlName="cc"></ion-toggle>
              </ion-item>
            </ion-card>
            <ion-card>
              <ion-card-header><ion-card-title>Booking introduction</ion-card-title></ion-card-header>          
              <ion-card-content>
              <span class='sm-pale'>This booking introduction will show on your <a href='{{siteUrl}}' target='_blank'>client booking page</a>.</span>
              <br /><br />   
              
              <quill-editor class="quill-custom-email" formControlName="bookingIntro" [modules]="config"></quill-editor>
              </ion-card-content>
            </ion-card>

            <ion-card>
              <ion-card-header><ion-card-title>
                Cancellation Policy
              </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <span class='sm-pale'>This cancellation policy will show at the bottom of your <a href='{{siteUrl}}' target='_blank'>client booking pages</a> and on all your emails.</span>
                <br /><br />
                <ion-textarea 
                  name='' 
                  formControlName="cancellationPolicy"
                  [disabled]="!userService.getUser().isAdministrator() && userService.getSalon().sameCancellationPolicyForAllStaff == 1"
                  clearInput
                  class="sm-input-border"
                  >
                </ion-textarea>

                <ion-item [hidden]="cancellationPolicy.valid || (cancellationPolicy.pristine && !submitted)">
                  <p *ngIf="cancellationPolicy.hasError('maxlength')" class='sm-error'>
                    Cancellation Policy cannot exceed 100 characters.
                  </p>
                </ion-item>

                <ion-item lines="none">
                  <ion-select
                    formControlName="sameCancellationPolicyForAllStaff"
                    interface="popover"
                    [disabled]="!userService.getUser().isAdministrator()"
                    style="width:100%;max-width:100%;"
                    >
                      <ion-select-option 
                        *ngFor="let opt of cancellationPolicySlots" 
                        [value]="opt.value" class="ion-text-wrap">
                          {{ opt.text }}
                      </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-card-content>
            </ion-card>
            <br/>
        
          </ion-col>
    </ion-row>
 </form> 
  </ng-container>

</ion-content>

<ion-footer class="ion-no-margin hidden-md-up">
  <ion-toolbar class="ion-no-margin ion-no-padding">
      <ion-button 
        expand="block" 
        
        fill="solid"
        color="primary"
        [disabled]="isLoading || errorOccurredWhileLoadingStylistPicker" 
        (click)="onBookingSettingsSave()">
        Save
      </ion-button>
  </ion-toolbar>
</ion-footer>
